const DASHBOARD_TABS = {
  NOTIFICATION: "notification",
  ALERT: "alert"
};

const DASHBOARD_IDS = {
  NOTIFICATION: 1,
  ALERT: 2
};

module.exports = {
  DASHBOARD_TABS,
  DASHBOARD_IDS
};